import { PageHeader, Collapse, Table, Row, Col } from 'antd';
import React from 'react';

import { useNavigate, useLocation  } from 'react-router-dom'

import SearchPolicyStore from '../../store/slice/search.policy.slice';

import { Render2Column, MiniLoader } from '../utility/componentUtility'

import doUtility from '../utility'

const { Panel } = Collapse;

function IPolicyEnqDetails () {

    const location = useLocation();

    const navigate = useNavigate()

    const EnqResponse_DET     = SearchPolicyStore((state) => state.EnqResponse_DET)
    const EnqResponse_FUND    = SearchPolicyStore((state) => state.EnqResponse_FUND)
    const EnqResponse_RIDER   = SearchPolicyStore((state) => state.EnqResponse_RIDER)
    const EnqResponse_NOMINEE = SearchPolicyStore((state) => state.EnqResponse_NOMINEE)
    const EnqResponse_PREM    = SearchPolicyStore((state) => state.EnqResponse_PREM)

    const Enq_DET     = SearchPolicyStore((state) => state.Enq_DET)
    const Enq_FUND    = SearchPolicyStore((state) => state.Enq_FUND)
    const Enq_RIDER   = SearchPolicyStore((state) => state.Enq_RIDER)
    const Enq_NOMINEE = SearchPolicyStore((state) => state.Enq_NOMINEE)
    const Enq_PREM    = SearchPolicyStore((state) => state.Enq_PREM)
    
    const policy_no = location.state.policy_no;

    const accordianChange = (e) =>{

        if( e === '1' && EnqResponse_DET === null){
            Enq_DET(policy_no)

        }else if( e === '2' && EnqResponse_RIDER === null){
            Enq_RIDER(policy_no)
        
        }else if( e === '3' && EnqResponse_NOMINEE === null){
            Enq_NOMINEE(policy_no)
        
        }else if( e === '4' && EnqResponse_FUND === null){
            Enq_FUND(policy_no)
        
        }else if( e === '5' && EnqResponse_PREM === null){
            Enq_PREM(policy_no)
        
        }
        
    }

    return (
        <div className='dashboard' >

            <div className='back-white'>

                <PageHeader
                    className="site-page-header"
                    onBack={() => navigate(-1)}
                    title="Detail View"
                    subTitle={policy_no}
                />

                <div className='policy_viewDetails'>
                    <Collapse accordion onChange={accordianChange}>
                        <Panel header="Basic Details" key="1">
                            
                            {( () => {
                                if(EnqResponse_DET === 'loading'){
                                    return (
                                        <MiniLoader />
                                    )
                                }else if(EnqResponse_DET !== null){
                                    const half = Math.ceil(Object.keys(EnqResponse_DET).length / 2);    
                                    return (
                                        <Row className='custom-row'>
                                            <Col md={11} className='child'>
                                                {
                                                    Object.entries(EnqResponse_DET).slice(0, half).map((item, key) => {
                                                        return <Render2Column col1={item[0].replaceAll('_', ' ').replace('x002F', '/')} col2={item[1]} key={key} />
                                                    }) 
                                                }
                                            </Col>
                                            <Col md={12} className='child'>
                                                {
                                                    Object.entries(EnqResponse_DET).slice(half).map((item, key) => {
                                                        return <Render2Column col1={item[0].replaceAll('_', ' ').replace('x002F', '/')} col2={item[1]} key={key} />
                                                    }) 
                                                }
                                            </Col>
                                        </Row>
                                    ) 
                                }
                            }) ()}
 
                        </Panel>
                        <Panel header="Policy Benefits" key="2">
                            {( () => {
                                if (EnqResponse_RIDER !== null) {
                                    if(EnqResponse_RIDER === 'loading'){
                                        return (
                                            <MiniLoader />
                                        )
                                    }else{
                                        const dataEnqRider = doUtility.RenderTableData(EnqResponse_RIDER)
                                        return (
                                            <Table
                                                className='back-white' 
                                                style={{ margin: 'auto', borderRadius: '2px'}} 
                                                dataSource={dataEnqRider.datasource} columns={dataEnqRider.column} />
                                        )
                                    }
                                }
                            }) ()}
                        </Panel>
                        <Panel header="Policy Nominees" key="3">
                            {( () => {
                                if (EnqResponse_NOMINEE !== null) {
                                    if(EnqResponse_NOMINEE === 'loading'){
                                        return (
                                            <MiniLoader />
                                        )
                                    }else{
                                        const dataEnqNOMINEE = doUtility.RenderTableData(EnqResponse_NOMINEE)
                                        return (
                                            <Table
                                                className='back-white' 
                                                style={{ margin: 'auto', borderRadius: '2px'}} 
                                                dataSource={dataEnqNOMINEE.datasource} columns={dataEnqNOMINEE.column} />
                                        )
                                    }
                                }
                            }) ()}
                        </Panel>
                        <Panel header="Policy Funds" key="4">
                            {( () => {
                                if (EnqResponse_FUND !== null) {
                                    if(EnqResponse_FUND === 'loading'){
                                        return (
                                            <MiniLoader />
                                        )
                                    }else{
                                        const dataEnqFUND = doUtility.RenderTableData(EnqResponse_FUND)
                                        return (
                                            <Table
                                            rowKey="key"
                                                className='back-white' 
                                                style={{ margin: 'auto', borderRadius: '2px'}} 
                                                dataSource={dataEnqFUND.datasource} columns={dataEnqFUND.column} />
                                        )
                                    }
                                }
                            }) ()}  
                        </Panel>
                        <Panel header="Policy Premium" key="5">
                            {( () => {
                                if (EnqResponse_PREM !== null) {

                                    if(EnqResponse_PREM === 'loading'){
                                        return (
                                            <MiniLoader />
                                        )
                                    }else{
                                        const dataEnqPREM = doUtility.RenderTableData(EnqResponse_PREM)
                                        const dataEnqPREM2 = doUtility.RenderTableData2(EnqResponse_PREM)
                                        return (
                                            <Table
                                                className='back-white' 
                                                style={{ margin: 'auto', borderRadius: '2px'}} 
                                                dataSource={dataEnqPREM.datasource} columns={dataEnqPREM.column}  rowKey="key"/>
                                        )
                                    }
                                }
                            }) ()}
                        </Panel>
                    </Collapse>
                </div>
            </div>
        </div>
    )
}

export default IPolicyEnqDetails